import React, { useRef } from 'react';
import styled from 'styled-components/macro';

import useMedia from 'hooks/useMedia';
import useReorderDragDrop from 'hooks/useReorderDragDrop';

import { ReactComponent as DragIcon } from 'icons/icon-drag.svg';
import { ReactComponent as IconRemove } from 'icons/icon-remove.svg';
import {
  DragHandler,
  RemoveButton,
} from 'components/Selector/DSPSelector/SelectedDSPList/DSPItem/DSPItem';
import { TTableHeader } from './CustomizeView';

import { ThemeProps } from 'types/styled';

const Item = styled.div<ThemeProps<'div'>>`
  background: white;
  display: flex;
  font-weight: 600;
  padding: ${({ theme }): string => `${theme.spacing.xxsmall} 0`};
  opacity: ${({ isDragging }): number => (isDragging ? 0.3 : 1)};
  align-items: center;
`;

export const Displayname = styled.span<ThemeProps<'span'>>`
  font-family: Proxima Nova;
  font-size: 16px;
  font-weight: normal;
  line-height: 3;
  color: ${({ theme }): string => theme.NightBlue};
  user-select: none;
  flex-grow: 1;
`;

interface IViewItem {
  item: TTableHeader;
  index: number;
  changeOrder: (start: number, end: number) => void;
  handleChecked: (value: string) => void;
  isRemovable: boolean;
}

const ViewItem: React.FC<IViewItem> = (props) => {
  const { item, index, changeOrder, handleChecked, isRemovable } = props;
  const ref = useRef(null);
  const isLargeScreen = useMedia('(min-width: 34.375rem)');

  const { isDragging } = useReorderDragDrop(ref, item, index, changeOrder);
  const opacity = isDragging ? 0 : 1;

  return (
    <li ref={ref} style={{ opacity }}>
      <div onMouseDown={(e: any): void => e.preventDefault()}>
        <Item isDragging={isDragging}>
          {isLargeScreen && (
            <RemoveButton
              onClick={(): void => handleChecked(item.value)}
              isRemovable={isRemovable}
            >
              <IconRemove />
            </RemoveButton>
          )}
          <Displayname>{item.label}</Displayname>
          <div>
            <DragHandler onMouseDown={(e: any): any => e.stopPropagation()}>
              {isRemovable && <DragIcon />}
            </DragHandler>
          </div>
        </Item>
      </div>
    </li>
  );
};

export default ViewItem;
